// Support-ticket category taxonomy for the in-app "Request Support" widget.
//
// FALLBACK_CATEGORIES is used when GET /support/categories is unavailable, so
// the user always has a usable list. ROUTE_CATEGORY_RULES picks the default
// category from the screen the user was on when they asked for help.

export const DEFAULT_CATEGORY = 'Bug Report';

export const FALLBACK_CATEGORIES = [
  { header: 'Hardware' },
  { text: 'Printer', value: 'Hardware > Printer' },
  { text: 'Scanner', value: 'Hardware > Scanner' },
  { text: 'Network', value: 'Hardware > Network' },
  { text: 'Password Reset', value: 'Hardware > Password Reset' },
  { text: 'Email', value: 'Hardware > Email' },
  { text: 'Other Hardware', value: 'Hardware > Other' },
  { divider: true },
  { header: 'Tax' },
  { text: 'Tax Inquiry', value: 'Tax > Tax Inquiry' },
  { text: 'Payments', value: 'Tax > Payments' },
  { text: 'Adjustments', value: 'Tax > Adjustments' },
  { text: 'Mortgage Co', value: 'Tax > Mortgage Co' },
  { text: 'Delinquent Tax', value: 'Tax > Delinquent Tax' },
  { text: 'Other Tax', value: 'Tax > Other' },
  { divider: true },
  { header: 'Bookkeeping' },
  { text: 'General Ledger', value: 'Bookkeeping > General Ledger' },
  { text: 'Misc Receipts', value: 'Bookkeeping > Misc Receipts' },
  { text: 'Mortgage Tax', value: 'Bookkeeping > Mortgage Tax' },
  { text: 'Official Depository', value: 'Bookkeeping > Official Depository' },
  { text: 'Warrants', value: 'Bookkeeping > Warrants' },
  { text: 'Other Bookkeeping', value: 'Bookkeeping > Other' },
  { divider: true },
  { header: 'End of Month' },
  { text: 'Apportionment', value: 'End of Month > Apportionment' },
  { text: 'Posting Period', value: 'End of Month > Posting Period' },
  { text: 'Balancing', value: 'End of Month > Balancing' },
  { divider: true },
  { header: 'Forte / RenewGov' },
  { text: 'Credit Cards', value: 'Forte / RenewGov > Credit Cards' },
  { text: 'Online Payments', value: 'Forte / RenewGov > Online Payments' },
  { text: 'In-Office Payments', value: 'Forte / RenewGov > In-Office Payments' },
  { divider: true },
  { text: 'Bug Report', value: DEFAULT_CATEGORY },
  { text: 'Billing Question', value: 'Billing Question' },
];

// Ordered — first match wins. Each `match` entry is tested against the
// lower-cased route name ("General Ledger - Transactions") when it is a plain
// string, or against the route path ("/gl/transactions") when it starts with a
// slash.
export const ROUTE_CATEGORY_RULES = [
  { match: ['general ledger', '/gl'], category: 'Bookkeeping > General Ledger' },
  { match: ['mortgage tax', '/mtg'], category: 'Bookkeeping > Mortgage Tax' },
  {
    match: ['tax - payments', 'tax-payments', '/tax/payments'],
    category: 'Tax > Payments',
  },
  { match: ['delinquent tax', '/tax/delinquent'], category: 'Tax > Delinquent Tax' },
  {
    match: ['tax roll adjustment', 'tax-tax roll', '/tax/adjustments'],
    category: 'Tax > Adjustments',
  },
  {
    match: ['mortgage co', 'mortgage-co', '/tax/mortgageco'],
    category: 'Tax > Mortgage Co',
  },
  { match: ['tax', '/tax'], category: 'Tax > Tax Inquiry' },
  { match: ['misc receipt', '/od/misc'], category: 'Bookkeeping > Misc Receipts' },
  { match: ['official depository', '/od'], category: 'Bookkeeping > Official Depository' },
  { match: ['warrant', '/warrant'], category: 'Bookkeeping > Warrants' },
  {
    match: ['apportionment', 'end of month', 'eom'],
    category: 'End of Month > Apportionment',
  },
];

export function categoryForRoute(route) {
  const r = (route || '').toLowerCase();
  if (!r) return DEFAULT_CATEGORY;
  const rule = ROUTE_CATEGORY_RULES.find(({ match }) => match.some(
    (m) => (m.startsWith('/') ? r.startsWith(m) : r.includes(m)),
  ));
  return rule ? rule.category : DEFAULT_CATEGORY;
}
